module.exports = __webpack_public_path__ + "img/rectangle-vertical.07bb9e8c.svg";